import React from 'react';
import moment from 'moment';
import cx from 'classnames';
import { connect } from 'react-redux';
import { change } from 'redux-form';
import { injectIntl } from 'react-intl';
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';
import withStyles from 'isomorphic-style-loader/withStyles';

import { isRTL } from '../../../helpers/formatLocale';
import calendarCloseIcon from '../../../../public/Icons/calendarCloseIcon.svg';

import s from 'react-dates/lib/css/_datepicker.css';
import cs from '../../../styles/reactDatesCalendar.css';


class DatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      focused: false,
      date: null,
      daySize: 42,
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount() {
    const { initialDate } = this.props;
    if (initialDate) {
      this.setState({ date: moment(initialDate) });
    }
    this.handleResize();
    if (typeof window !== 'undefined') {
      window.addEventListener("resize", this.handleResize);
    }
  }
  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener("resize", this.handleResize);
    }
  }

  handleResize() {
    const daySize = window.innerWidth <= 350 ? 34 : 42;
    this.setState({ daySize });
  }


  UNSAFE_componentWillReceiveProps(nextProps, prevProps) {
    const { initialDate } = nextProps;
    if (initialDate) {
      this.setState({ date: moment(initialDate) });
    }
  }

  onDateChange(date) {
    const { change, formName, fieldName, handleDateChange } = this.props;
    const { focused } = this.state;

    if (formName && fieldName) {
      change(formName, fieldName, date);
    }

    handleDateChange && handleDateChange(date);

    this.setState({ date });
    this.setState({ focused: !date && focused ? false : focused })
  }

  onFocusChange({ focused }) {
    this.setState({ focused });
  }

  render() {
    const { placeholder, locale, isDayBlocked, block, containerClassName, showClearDate } = this.props;
    const { focused, date, daySize } = this.state;

    return (
      <div className={cx(containerClassName, 'svgImg')}>
        <SingleDatePicker
          onDateChange={this.onDateChange}
          onFocusChange={this.onFocusChange}
          focused={focused}
          date={date}
          placeholder={placeholder}
          readOnly
          daySize={daySize}
          id={'DatePickerId'}
          numberOfMonths={1}
          hideKeyboardShortcutsPanel
          showClearDate={showClearDate}
          anchorDirection={isRTL(locale) ? 'right' : 'left'}
          isRTL={isRTL(locale)}
          // isDayBlocked={day => isDayBlocked ? isDayBlocked(day) : null}
          block={block}
          displayFormat={'DD/MM/YYYY'}
          customCloseIcon={<img className='adminCalenderCustomCloseIcon' src={calendarCloseIcon} alt="calendarCloseIcon" />}
        />
      </div>
    );
  }
}

const mapState = state => ({
  locale: state.intl.locale
});

const mapDispatch = {
  change
};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(DatePicker)));

